import Production from '../src/Production/index.tsx';
export default Production;
